import { SIGNATURE_FONT_FAMILY, SIGNATURE_FONT_SIZE } from './e-signature/constants';

export const getInitials = (firstName: string, lastName?: string): string => {
    const firstInitial = firstName.charAt(0).toUpperCase();
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
};

export const getSubdomain = (): string | null => {
    const hostname: string = window.location.hostname;
    const parts: string[] = hostname.split('.');

    if (parts.length > 2 && !parts[0].includes('pharmanavigator')) {
        return parts[0];
    }

    return null;
};

export const generateSignatureText = async ({
    ctx,
    name,
    width,
    height,
}: {
    ctx: CanvasRenderingContext2D;
    name: string;
    width: number;
    height: number;
}) => {
    let fontSize = SIGNATURE_FONT_SIZE;

    await document.fonts.load(`${fontSize}px ${SIGNATURE_FONT_FAMILY}`);

    do {
        ctx.font = `${fontSize}px ${SIGNATURE_FONT_FAMILY}`;
        fontSize -= 1;
    } while (ctx.measureText(name).width > width);

    ctx.textBaseline = 'middle';
    ctx.font = `${fontSize}px ${SIGNATURE_FONT_FAMILY}`;

    const textWidth = ctx.measureText(name).width;
    const x = (width - textWidth) / 2;
    const y = height / 2;

    ctx.fillText(name, x, y);
};
